export const NETWORK_ERROR = "network_error";
